import { ReactElement } from 'react';
import { FieldProps, ErrorMessage, useFormikContext, getIn } from 'formik';

import classnames from 'classnames';
import styles from './TextInput.module.scss';

interface iProps extends FieldProps {
  title?: string;
  subtitle: string;
  isMandatory: boolean;
  placeholder: string;
  icon?: any;
  iconPosition?: 'start' | 'end';
  iconClick?: () => void;
  onChange?: (e: any) => void;
  type?: string;
  disabled: boolean;
  autocomplete?: string;
}

const TextInput = ({ field, title = '', subtitle, isMandatory, placeholder, icon, iconPosition = 'start', iconClick, type = 'text', disabled, onChange, autocomplete = 'on' }: iProps): ReactElement => {
  const { errors, touched }: { errors: any; touched: any } = useFormikContext();
  const hasError = getIn(errors, field.name);
  const touchedError = getIn(touched, field.name);
  const customisedErrorMessage = (errorMessage: string): ReactElement => {
    if (errorMessage.includes('<>')) {
      const removedChars = errorMessage.replace('<>', '');
      return (
        <span className={styles.errorMsg}>
          {removedChars}
          {' '}
          <i>{'<>'}</i>
        </span>
      );
    }
      return <span className={styles.errorMsg}>{errorMessage}</span>;
  };
  const extraInputAttrs: any = {};
  if (onchange) {
    extraInputAttrs.onChange = onChange;
  }

  return (
    <div
      className={classnames({
        [styles.container]: true,
        [styles.titlePresent]: title,
      })}>
      {title && (
        <div
          className={classnames({
            [styles.title]: true,
            [styles.titleError]: hasError && touchedError,
          })}>
          <span className={styles.titleBold}>{title}</span>
          {!isMandatory && <span className={styles.optional}> ( optional )</span>}
          {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        </div>
      )}
      <div className={styles.inputContainer}>
        <input
          type={type}
          className={classnames({
            [styles.formInput]: true,
            [styles.inputLeftPadding]: icon && iconPosition === 'start',
            [styles.inputError]: hasError && touchedError,
            [styles.disabled]: disabled,
          })}
          required={isMandatory}
          placeholder={placeholder}
          disabled={disabled}
          {...field}
          value={field.value ? field.value : ''}
          {...extraInputAttrs}
          autoComplete={autocomplete}
          aria-label="Text Input"
        />
        {icon && !iconClick && (
          <div>
            <img
              className={classnames({
                [styles.iconContainerStart]: iconPosition === 'start',
                [styles.iconContainerEnd]: iconPosition === 'end',
              })}
              src={icon}
              alt="icon" />
          </div>
        )}
        {icon && iconClick && (
          <button
            type="button"
            onClick={iconClick}
            className={classnames({
              [styles.iconContainerStart]: iconPosition === 'start',
              [styles.iconContainerEnd]: iconPosition === 'end',
              [styles.iconButton]: true,
            })}>
            <img src={icon} alt="icon" />
          </button>
        )}
      </div>
      <ErrorMessage name={field.name} render={(msg) => customisedErrorMessage(msg)} />
    </div>
  );
};

export default TextInput;
